import { User } from './user'

export type Connection = {
  id: number
  displayName: string
  userId: User['id']
  status: ConnectionStatus
  isSystem: boolean
  type: ConnectionType
  apiKey?: string
  stripeAccountId?: string
  stripeSecretKey?: string
  createdAt: Date
  updatedAt: Date
  accessToken?: string
  refreshToken?: string
  tokenExpiryDate?: Date
  propertyId?: string
  slackBotUserId?: string
  slackBotAccessToken?: string
  slackTeamId?: string
  slackTeamName?: string
  slackAppId?: string
  slackInstalledByUserId?: string
  slackScopes?: string
  host?: string
  port?: number
  database?: string
  username?: string
  password?: string
  enableSsl?: boolean
  verifyServerCertificate?: boolean
  sslCert?: string
  gmailEmailAddress?: string
  metadata?: Record<string, any>
  apiDomain?: string
}

export type ConnectionSummary = Pick<
  Connection,
  | 'id'
  | 'type'
  | 'displayName'
  | 'isSystem'
  | 'userId'
  | 'createdAt'
  | 'updatedAt'
  | 'status'
>

export type PipedriveMetadata = {
  companyDomain: string
}

export enum ConnectionStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  INVALID = 'invalid',
  DISABLED = 'disabled',
}

export enum ConnectionType {
  STRIPE = 'stripe',
  GOOGLE_ANALYTICS = 'google-analytics',
  SLACK = 'slack',
  POSTGRES = 'postgres',
  OPENAI = 'openai',
  APOLLO = 'apollo',
  GMAIL = 'gmail',
  PIPEDRIVE = 'pipedrive',
  PERPLEXITY_AI = 'perplexity-ai',
  RESEND = 'resend',
  GITLAB = 'gitlab',
  LINEAR = 'linear',
}

export const ConnectionTypeDisplayNames: { [key in ConnectionType]: string } = {
  [ConnectionType.STRIPE]: 'Stripe',
  [ConnectionType.GOOGLE_ANALYTICS]: 'Google Analytics',
  [ConnectionType.SLACK]: 'Slack',
  [ConnectionType.POSTGRES]: 'Postgres',
  [ConnectionType.OPENAI]: 'OpenAI',
  [ConnectionType.APOLLO]: 'Apollo',
  [ConnectionType.GMAIL]: 'Gmail',
  [ConnectionType.PIPEDRIVE]: 'Pipedrive',
  [ConnectionType.PERPLEXITY_AI]: 'Perplexity AI',
  [ConnectionType.RESEND]: 'Resend',
  [ConnectionType.GITLAB]: 'GitLab',
  [ConnectionType.LINEAR]: 'Linear',
}

export type ConnectionData = {
  name: string
  description: string
  type: ConnectionType
}

export const connectionsData: ConnectionData[] = [
  {
    name: 'Google Analytics 4 (GA4)',
    description: 'Google Analytics 4 connection',
    type: ConnectionType.GOOGLE_ANALYTICS,
  },
  {
    name: 'Slack',
    description: 'Slack connection',
    type: ConnectionType.SLACK,
  },
  {
    name: 'Postgres',
    description: 'Postgres connection',
    type: ConnectionType.POSTGRES,
  },
  {
    name: 'OpenAI',
    description: 'OpenAI connection',
    type: ConnectionType.OPENAI,
  },
  {
    name: 'Apollo',
    description: 'Apollo connection',
    type: ConnectionType.APOLLO,
  },
  {
    name: 'Gmail',
    description: 'Gmail connection',
    type: ConnectionType.GMAIL,
  },
  {
    name: 'Pipedrive',
    description: 'Pipedrive connection',
    type: ConnectionType.PIPEDRIVE,
  },
  {
    name: 'Perplexity AI',
    description: 'Perplexity AI connection',
    type: ConnectionType.PERPLEXITY_AI,
  },
  {
    name: 'Resend',
    description: 'Resend connection',
    type: ConnectionType.RESEND,
  },
  {
    name: 'GitLab',
    description: 'GitLab connection',
    type: ConnectionType.GITLAB,
  },
  {
    name: 'Linear',
    description: 'Linear connection',
    type: ConnectionType.LINEAR,
  },
]
